export default "__VITE_ASSET__180ad626__"